module.exports = __webpack_public_path__ + "img/3.b68abd87.png";